/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiExperiment } from './ApiExperiment';
import {
  ApiExperimentFromJSON,
  ApiExperimentFromJSONTyped,
  ApiExperimentToJSON,
  ApiExperimentToJSONTyped,
} from './ApiExperiment';

/**
 *
 * @export
 * @interface ApiListExperimentsResponse
 */
export interface ApiListExperimentsResponse {
  /**
   * A list of experiments returned.
   * @type {Array<ApiExperiment>}
   * @memberof ApiListExperimentsResponse
   */
  experiments?: Array<ApiExperiment>;
  /**
   * The total number of experiments for the given query.
   * @type {number}
   * @memberof ApiListExperimentsResponse
   */
  total_size?: number;
  /**
   * The token to list the next page of experiments.
   * @type {string}
   * @memberof ApiListExperimentsResponse
   */
  next_page_token?: string;
}

/**
 * Check if a given object implements the ApiListExperimentsResponse interface.
 */
export function instanceOfApiListExperimentsResponse(
  value: object,
): value is ApiListExperimentsResponse {
  return true;
}

export function ApiListExperimentsResponseFromJSON(json: any): ApiListExperimentsResponse {
  return ApiListExperimentsResponseFromJSONTyped(json, false);
}

export function ApiListExperimentsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiListExperimentsResponse {
  if (json == null) {
    return json;
  }
  return {
    experiments:
      json['experiments'] == null
        ? undefined
        : (json['experiments'] as Array<any>).map(ApiExperimentFromJSON),
    total_size: json['total_size'] == null ? undefined : json['total_size'],
    next_page_token: json['next_page_token'] == null ? undefined : json['next_page_token'],
  };
}

export function ApiListExperimentsResponseToJSON(json: any): ApiListExperimentsResponse {
  return ApiListExperimentsResponseToJSONTyped(json, false);
}

export function ApiListExperimentsResponseToJSONTyped(
  value?: ApiListExperimentsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experiments:
      value['experiments'] == null
        ? undefined
        : (value['experiments'] as Array<any>).map(ApiExperimentToJSON),
    total_size: value['total_size'],
    next_page_token: value['next_page_token'],
  };
}
